/** A ticket message is either a comment or a system row recording a status change. */
export enum ServiceDeskMessageKind {
  Comment = 0,
  StatusChanged = 1,
}
